// extracted by mini-css-extract-plugin
module.exports = {"player":"Player_player__Qok3y","isTurn":"Player_isTurn__1uEOZ","name":"Player_name__2g9Vw","score":"Player_score__18r5G"};